import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import styled from 'styled-components'
import { openSidePanelPopOver } from '../../dux/ui/actions'

const FabButton = styled.a`
  background: #1d4ed8;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  text-align:center;
  color: #FFF !important;
  box-shadow:0px 0px 3px rgba(0,0,0,0.2),3px 3px 3px rgba(0,0,0,0.21);
  position: fixed;
  bottom: 16px;
  font-size: 28px;
  display: inline-block;
  cursor: pointer;
  display:block;
  text-decoration: none !important;
`

export default function FabButtons({ isStaffApp }){
  const { organization, config, resident } = useSelector(state=>state)
  const { showSidePanel } = config
  const dispatch = useDispatch()

  return(
    <div className="d-block d-lg-none">
      {
        !isStaffApp &&
        <>
          {
            showSidePanel &&
            <FabButton
              style={{left: '16px'}}
              onClick={()=>dispatch(openSidePanelPopOver())}>☰</FabButton>
          }
          <FabButton
            href={`/organizations/${organization.name}/new_agenda_resource${ !!resident.id ? `?from_resident_profile=${resident.id || ''}` : ''}`}
            style={{right: '16px'}}>+</FabButton>
        </>
      }
    </div>
  )
}